import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router';
import { createUseStyles } from 'features/sharedModules/styles/components/styles.js';
import * as R from 'ramda';

import { i18n } from 'i18n/index.js';
import KnowledgeAbacus from 'assets/knowledge-icons/abacus.js';
import { usePrevRoute } from 'features/sharedModules/router/components/usePrevRoute.js';
import { useNextRoute } from 'features/sharedModules/router/components/useNextRoute.js';
import sessionSelectors from 'features/shared/services/session/selectors.js';
import userOptionsSelectors from 'features/shared/services/userOptions/selectors.js';
import { creators as userOptionsCreator } from 'features/shared/services/userOptions/actions.js';
import List from 'features/shared/components/list/index.js';
import Button, { ButtonType } from 'features/shared/components/button/index';
import Navigation from 'features/shared/components/screenLayout/navigation';
import { TextFontSizes } from 'features/shared/constants/fonts.js';
import { Colors } from 'features/shared/constants/colors';
import Layout from 'features/shared/components/screenLayout/layout.js';
import Page from 'features/shared/components/screenLayout/page.js';
import Footer from 'features/shared/components/screenLayout/footer.js';

const useStyles = createUseStyles(theme => {
  return {
    subTitle: {
      fontFamily: theme.subTitleFontFamily,
      fontSize: TextFontSizes.largePx,
      lineHeight: TextFontSizes.largeLineHeightPx,
      textAlign: 'center',
      paddingTop: '50px',
      color: Colors.grayDark
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    contentHeader: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingBottom: '40px',
      paddingTop: '50px'
    },
    link: {
      fontFamily: theme.textFontFamily,
      fontSize: TextFontSizes.mediumPx,
      lineHeight: TextFontSizes.mediumLineHeightPx,
      textAlign: 'center',
      padding: '13px 0'
    }
  };
});

const Trading = () => {
  const classes = useStyles();
  const history = useHistory();
  const { customerId } = useParams();

  const prevRoute = usePrevRoute();
  const nextRoute = useNextRoute();

  const translations = useSelector(sessionSelectors.getTranslationsConfig);
  const trading = useSelector(sessionSelectors.getTradingConfig);
  const userOptions = useSelector(userOptionsSelectors.getUserOptions);

  const dispatch = useDispatch();
  const userOptionChanged = (type, value) => {
    dispatch(userOptionsCreator.userOptionChanged({ type, value }));
  };

  return (
    <Layout>
      <Navigation prevRoute={prevRoute} customerId={customerId}>
        {i18n('knowledge.trading.naviTitle', translations)}
      </Navigation>

      <Page>
        <div className={classes.content}>
          <div className={classes.contentHeader}>
            <KnowledgeAbacus />
            <span className={classes.subTitle}>
              {i18n('knowledge.trading.subTitle', translations)}
            </span>
          </div>

          <List
            options={trading}
            selectedOption={userOptions.trading}
            userOptionType="trading"
            onSelect={(type, item) => {
              userOptionChanged(type, item.id);
              window.scrollTo(0, document.body.scrollHeight);
            }}
          />
        </div>

        <Footer>
          {nextRoute && (
            <Button
              type={ButtonType.primary}
              disabled={R.isNil(userOptions.trading)}
              onClick={() => {
                history.push(nextRoute.build(customerId));
              }}
            >
              {i18n('shared.continue', translations)}
            </Button>
          )}
        </Footer>
      </Page>
    </Layout>
  );
};

export default Trading;
